// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    INNOVATION_BY_DESIGN_DETAIL_LOADING() {
      return {
        isLoading: true
      };
    },
    INNOVATION_BY_DESIGN_DETAIL_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesignDetail,
        year: action.year
      };
    },
    INNOVATION_BY_DESIGN_DETAIL_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignDetail.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
